import { ThemeOptions } from "@mui/material";
import { typographyVariants } from "../constants";

export const muiListItem: ThemeOptions["components"] = {
  MuiListItem: {
    styleOverrides: {
      root: {
        ...typographyVariants.bodyMedium,
      },
    },
  },
};
